const profile = {
  title: "自分のプロフィール",
  premiumBtn: "会員登録",
  orderInfoTitle: "アカウントの許可情報",
  tableStatus: "ステータス",
  tableProduct: "製品",
  tablePermissionDate: "許可日",
  tableValidPeriod: "有効期間",
  validStauts: "有効",
  expiredStauts: "無効",
  noData: "データ無し",
};

export default profile;
